import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-py-sm row justify-center rounded-borders" }
const _hoisted_2 = { class: "q-pa-md row justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "404", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'Error404',
  setup(__props) {


  let name = 'error404';


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, { class: "q-pa-md chb-card bg-white shadow-7" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_banner, { class: "row justify-center content-center" }, {
            avatar: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: "error",
                color: "pink-7"
              })
            ]),
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.pageNotFoundMsg')), 1)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})